<template>
    <v-card color="rgba(170,170,170,0.4)" height="100%" width="100%" tile>
          <v-card-title>
              
          </v-card-title>
          <v-card-subtitle>
              
          </v-card-subtitle>
          <v-divider></v-divider>
          <v-card-text class="ma-4 pa-4">
              <v-row>
                <v-col class="" cols="4">
                    <v-text-field label="Nome" outlined v-model="dados.dados.nome"></v-text-field>
                </v-col>
                <v-col class="" cols="4">
                    <v-text-field label="Email" outlined v-model="dados.dados.email"></v-text-field>
                </v-col>
                <v-col class="" cols="4">
                    <v-select :items="this.listaSexo" v-model="dados.dados.sexo" label="Sexo" outlined></v-select>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="" cols="4">
                    <v-menu ref="abrirDtNascimentoPicker" v-model="abrirDtNascimentoPicker" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
						<template v-slot:activator="{ on }">
							<v-text-field label="Data de Nascimento" v-model="dataNascimentoFormatada" v-on="on" outlined></v-text-field>
						</template>
						<v-date-picker locale="pt-br" v-model="dataNascimento" no-title @input="abrirDatePicker = false"></v-date-picker>
					</v-menu>
                </v-col>
                <v-col class="" cols="4">
                    <v-menu ref="" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
							<template v-slot:activator="{ on }">
								<v-text-field label="Horário de Nascimento" v-model="horaNascimento" v-on="on" outlined></v-text-field>
							</template>
							<v-time-picker format="24hr" v-model="horaNascimento" @input="menu1 = false"></v-time-picker>
						</v-menu>
                </v-col>
                <v-col class="" cols="4">
                    <v-menu ref="abrirDtIniciacaoPicker" v-model="abrirDtIniciacaoPicker" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
						<template v-slot:activator="{ on }">
							<v-text-field label="Data da Iniciação" v-model="dataIniciacaoFormatada" v-on="on" outlined></v-text-field>
						</template>
						<v-date-picker locale="pt-br" v-model="dataIniciacao" no-title @input="abrirDatePicker = false"></v-date-picker>
					</v-menu>
                </v-col>
            </v-row>
          </v-card-text>
      </v-card>
</template>
<script>
export default{
    props:['dados'],
    data(){
        return{
            abrirDtNascimentoPicker: false,
            abrirDtIniciacaoPicker: false,
            dataNascimento: '',
            dataNascimentoFormatada: '',
            dataIniciacao: '',
            dataIniciacaoFormatada: '',
            horaNascimento: '',
            iniciado: {},
            listaSexo: [
					{value: 'M', text: 'Masculino'},
					{value: 'F', text: 'Feminino'}
				],
        }
    },

    methods:{
        formataDateBr (dt) {
				if (!dt){
					return null
				} 
				const [year, month, day] = dt.split('-')
				const dataTxt = `${day}/${month}/${year}`
				return dataTxt
            },
            
            converterHora(hr){
                 let data = new Date(this.iniciado.dados.hrNascimento).toISOString().substr(0,10)
				 const [year, month, day] = data.split('-')
                 data = new Date(year, month-1, day, hr.substr(0,2), hr.substr(3,2))

				 return data
            },

            converterData(dt){
				let data = new Date(dt)
				let difHorario = data.getTimezoneOffset() / 60
				data = new Date(data.setHours(data.getHours() + difHorario))
				return data
			},
    },

    watch:{
        dataNascimento(val){
				this.dataNascimentoFormatada = this.formataDateBr(this.dataNascimento)
				this.iniciado.dados.dtNascimento = this.converterData(this.dataNascimento)
        },
        dataIniciacao(val){
				this.dataIniciacaoFormatada = this.formataDateBr(this.dataIniciacao)
				this.iniciado.dados.dtIniciacao = this.converterData(this.dataIniciacao)
        },
        horaNascimento(val){
                this.iniciado.dados.hrNascimento = this.converterHora(this.horaNascimento)
                
		},
    },

    created(){
        this.iniciado = this.dados
        this.dataNascimentoFormatada = this.formataDateBr(this.iniciado.dados.dtNascimento.toISOString().substr(0, 10))
        this.dataIniciacaoFormatada = this.formataDateBr(this.iniciado.dados.dtIniciacao.toISOString().substr(0, 10))
        this.horaNascimento = this.iniciado.dados.hrNascimento.toLocaleTimeString('pt-BR')
    }
}
</script>
<style scoped>

</style>